import React from "react";
import PropTypes from "prop-types";
import DockerContainer from "./DockerContainer";

const DockerContainersSection = ({ loadingDocker, dockerContainers, handleShowContainerLogs, handleRestartContainer, handleUploadConfig }) => {
  const renderContent = () => {
    if (loadingDocker) {
      return (
        <div className="loading-docker">
          <div className="spinner-small"></div>
          <span>Loading containers...</span>
        </div>
      );
    }

    if (dockerContainers.length > 0) {
      return (
        <div className="containers-grid">
          {dockerContainers.map((container) => (
            <DockerContainer
              key={container.Name}
              container={container}
              handleShowContainerLogs={handleShowContainerLogs}
              handleRestartContainer={handleRestartContainer}
              handleUploadConfig={handleUploadConfig}
            />
          ))}
        </div>
      );
    }

    return <p className="no-containers">No Docker containers found or Docker not running</p>;
  };

  return (
    <div>
      <h3>Docker Containers</h3>
      {renderContent()}
    </div>
  );
};

DockerContainersSection.propTypes = {
  loadingDocker: PropTypes.bool.isRequired,
  dockerContainers: PropTypes.array.isRequired,
  handleShowContainerLogs: PropTypes.func.isRequired,
  handleRestartContainer: PropTypes.func.isRequired,
  handleUploadConfig: PropTypes.func.isRequired,
};

export default DockerContainersSection;
